const getAppName = () => {
  const appName = '47awMaoQqtIaDLtHDdVW';
  return appName;
};

export default getAppName;